import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import { ProjectService } from "./project-service";
import { EntityService } from "./entity-service";

export class ProjectSharedDataService {

    static $inject = ["$q", "projectService", "entityService"];

    project: Models.IEntityCharDataPair;
    projectPromise: ng.IPromise<Models.IEntityCharDataPair>;

    projectInventory: Models.IEntityRelationshipPair[];
    inventoryPromise: ng.IPromise<Models.IEntityRelationshipPair[]>;

    projectStatus: Models.IEntityStatus;
    projectStatusPromise: ng.IPromise<Models.IEntityStatus>;

    constructor(private $q: ng.IQService,
        private projectService: ProjectService,
        private entityService: EntityService) {
        this.projectInventory = null;
        this.project = null;
        this.projectStatus = null;
    }

    RefreshInventory(projectID: string) {
        if (this.inventoryPromise == null) {
            this.inventoryPromise = this.entityService.getRelatedEntities(projectID, Consts.CharTypeIDs.project);
            this.inventoryPromise
                .then((result) => {
                    this.projectInventory = result;
                })
                .finally(() => {
                    this.projectPromise = null;
                });
        }
        return this.inventoryPromise || this.$q.when(this.projectInventory);
    }

    RefreshProject(projectID: string) {
        if (this.projectPromise == null) {
            this.projectPromise = this.entityService.getEntity(projectID);
            this.projectPromise
                .then((result) => {
                    this.project = result;
                })
                .finally(() => {
                    this.projectPromise = null;
                });
        }
        return this.projectPromise || this.$q.when(this.project);
    }

    RefreshProjectStatus(projectID: string): ng.IPromise<any> {
        if (this.projectStatusPromise == null) {
            this.projectStatusPromise = this.entityService.getEntityStatus(projectID);
            this.projectStatusPromise
                .then((result) => {
                    this.projectStatus = result;
                })
                .finally(() => {
                    this.projectStatusPromise = null;
                });
        }
        return this.projectStatusPromise || this.$q.when(this.project);
    }
}
